import { Link } from "react-router-dom";
import "../styles/globalmarquee.css";
import { FiCpu, FiCloud, FiBarChart2, FiBriefcase } from "react-icons/fi";

export default function GlobalMarquee() {
  return (
    <div className="global-marquee">
      <div className="marquee-track">

       <div className="marquee-content">
  <FiCpu className="marquee-icon" />
  <Link to="/job-readiness/gen-ai-starter">Gen AI Starter Program</Link>

  <span className="dot">•</span>

  <FiCloud className="marquee-icon" />
  <Link to="/job-readiness/cloud-computing-starter">Cloud Computing Starter Program</Link>

  <span className="dot">•</span>

  <FiBarChart2 className="marquee-icon" />
  <Link to="/job-readiness/data-analysis-starter">Data Analytics</Link>

  <span className="dot">•</span>

  <FiBriefcase className="marquee-icon" />
  <Link to="/syllabus/banking">Banking</Link>
</div>

<div className="marquee-content">
  <FiCpu className="marquee-icon" />
  <Link to="/job-readiness/gen-ai-starter">Gen AI Starter Program</Link>

  <span className="dot">•</span>

  <FiCloud className="marquee-icon" />
  <Link to="/job-readiness/cloud-computing-starter">Cloud Computing Starter Program</Link>

  <span className="dot">•</span>

  <FiBarChart2 className="marquee-icon" />
  <Link to="/job-readiness/data-analysis-starter">Data Analytics</Link>

  <span className="dot">•</span>

  <FiBriefcase className="marquee-icon" />
  <Link to="/syllabus/banking">Banking</Link>
</div>


        <div className="marquee-content">
  <FiCpu className="marquee-icon" />
  <Link to="/job-readiness/gen-ai-starter">Gen AI Starter Program</Link>

  <span className="dot">•</span>

  <FiCloud className="marquee-icon" />
  <Link to="/job-readiness/cloud-computing-starter">Cloud Computing Starter Program</Link>

  <span className="dot">•</span>

  <FiBarChart2 className="marquee-icon" />
  <Link to="/job-readiness/data-analysis-starter">Data Analytics</Link>

  <span className="dot">•</span>

  <FiBriefcase className="marquee-icon" />
  <Link to="/syllabus/banking">Banking</Link>
</div>

      </div>
    </div>
  );
}